import {Box, Text, Tooltip, VStack} from '@chakra-ui/react';
import {ArticleStatistiques} from 'api-types/tolede';
import {dateAvecSlashes} from 'ff-common';
import {Trans, useTranslation} from 'react-i18next';
import {CartCheckIcon} from '@/components/svg/CartCheckIcon';

type StatParLivraison = ArticleStatistiques['stats_par_livraison'][number];

/**
 * Contenu du tooltip « Vous avez déjà commandé X unités pour le DD/MM ».
 */
export const DejaCommandeTooltipContent: React.FC<{
  stats: StatParLivraison[];
  unite: string;
  date: string;
}> = ({stats, unite, date}) => {
  const {t} = useTranslation();
  return (
    <VStack
      alignItems='flex-start'
      spacing='0'
    >
      {stats.map((stat, idx) => (
        <VStack
          key={idx}
          alignItems='flex-start'
          spacing='0'
        >
          <Text
            fontSize='sm'
            color='orange.warning'
          >
            {t('commande.deja_commande_tooltip_ligne1')}
          </Text>
          <Text
            fontSize='sm'
            color='orange.warning'
          >
            <Trans
              i18nKey='commande.deja_commande_tooltip_ligne2'
              values={{
                quantite: stat.quantite,
                unite: t(`unite.${unite}`, {count: stat.quantite}),
                date: dateAvecSlashes(date),
              }}
              components={{
                bold: (
                  <Text
                    as='span'
                    fontWeight='700'
                  />
                ),
              }}
            />
          </Text>
        </VStack>
      ))}
    </VStack>
  );
};

/**
 * Picto « déjà commandé »
 */
export const DejaCommandeIcon: React.FC = () => (
  <CartCheckIcon
    width='20px'
    height='20px'
    color='orange.warning'
  />
);

/**
 * Badge minimal « déjà commandé » affiché en fallback quand un article est déjà commandé pour la date courante
 * mais n'a pas encore d'historique d'achat.
 */
export const DejaCommandeBadge: React.FC<{
  stats: StatParLivraison[];
  unite: string;
  date: string;
}> = ({stats, unite, date}) => (
  <Tooltip
    bg='white'
    color='orange.warning'
    border='1px solid'
    borderColor='gray.light'
    borderRadius='8px'
    boxShadow='md'
    p='3'
    label={
      <DejaCommandeTooltipContent
        stats={stats}
        unite={unite}
        date={date}
      />
    }
  >
    <Box
      display='inline-flex'
      alignItems='center'
      border='1px solid'
      borderColor='orange.warning'
      borderRadius='6px'
      background='yellow.50'
      px='1'
      py='1'
      cursor='default'
    >
      <DejaCommandeIcon />
    </Box>
  </Tooltip>
);
